import Session from '../../../Utils/Sessions';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE = `${BASE_URL}api/v1/academics`;

const getAuthHeaders = () => {
  const token = Session.get('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Token ${token}` }),
  };
};

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Request failed' }));
    throw new Error(error.detail || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

// Courses API
export const fetchCourses = async (page = 1, pageSize = 10) => {
  const response = await fetch(
    `${API_BASE}/finance/courses/?page=${page}&page_size=${pageSize}`,
    { headers: getAuthHeaders() }
  );
  return handleResponse(response);
};

export const exportCoursesExcel = async () => {
  const response = await fetch(
    `${API_BASE}/finance/courses/export-excel/`,
    { headers: getAuthHeaders() }
  );
  if (!response.ok) throw new Error('Export failed');

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `courses_finance_${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// Specializations API
export const fetchSpecializations = async (courseId, page = 1, pageSize = 10) => {
  const url = courseId
    ? `${API_BASE}/finance/courses/${courseId}/specializations/?page=${page}&page_size=${pageSize}`
    : `${API_BASE}/finance/specializations/?page=${page}&page_size=${pageSize}`;

  const response = await fetch(url, { headers: getAuthHeaders() });
  return handleResponse(response);
};

export const exportSpecializationsExcel = async (courseId) => {
  const url = courseId
    ? `${API_BASE}/finance/courses/${courseId}/specializations/export-excel/`
    : `${API_BASE}/finance/specializations/export-excel/`;

  const response = await fetch(url, { headers: getAuthHeaders() });
  if (!response.ok) throw new Error('Export failed');

  const blob = await response.blob();
  const url_obj = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url_obj;
  a.download = `specializations_finance_${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url_obj);
};

// Academic Groups API
export const fetchAcademicGroups = async (specializationId, page = 1, pageSize = 10) => {
  const url = specializationId
    ? `${API_BASE}/finance/courses/${Math.floor(Math.random() * 1000)}/specializations/${specializationId}/academic-groups/?page=${page}&page_size=${pageSize}`
    : `${API_BASE}/finance/academic-groups/?page=${page}&page_size=${pageSize}`;

  const response = await fetch(url, { headers: getAuthHeaders() });
  return handleResponse(response);
};

export const exportAcademicGroupsExcel = async (specializationId) => {
  const url = specializationId
    ? `${API_BASE}/finance/courses/${Math.floor(Math.random() * 1000)}/specializations/${specializationId}/academic-groups/export-excel/`
    : `${API_BASE}/finance/academic-groups/export-excel/`;

  const response = await fetch(url, { headers: getAuthHeaders() });
  if (!response.ok) throw new Error('Export failed');

  const blob = await response.blob();
  const url_obj = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url_obj;
  a.download = `academic_groups_finance_${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url_obj);
};

// Least Academic Groups API
export const fetchLeastAcademicGroups = async (academicGroupId, page = 1, pageSize = 10) => {
  const url = academicGroupId
    ? `${API_BASE}/finance/courses/${Math.floor(Math.random() * 1000)}/specializations/${Math.floor(Math.random() * 1000)}/academic-groups/${academicGroupId}/least-academic-groups/?page=${page}&page_size=${pageSize}`
    : `${API_BASE}/finance/least-academic-groups/?page=${page}&page_size=${pageSize}`;

  const response = await fetch(url, { headers: getAuthHeaders() });
  return handleResponse(response);
};

export const exportLeastAcademicGroupsExcel = async (academicGroupId) => {
  const url = academicGroupId
    ? `${API_BASE}/finance/courses/${Math.floor(Math.random() * 1000)}/specializations/${Math.floor(Math.random() * 1000)}/academic-groups/${academicGroupId}/least-academic-groups/export-excel/`
    : `${API_BASE}/finance/least-academic-groups/export-excel/`;

  const response = await fetch(url, { headers: getAuthHeaders() });
  if (!response.ok) throw new Error('Export failed');

  const blob = await response.blob();
  const url_obj = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url_obj;
  a.download = `least_academic_groups_finance_${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url_obj);
};

// Students API
export const fetchStudents = async (leastAcademicGroupId, page = 1, pageSize = 10) => {
  const url = leastAcademicGroupId
    ? `${API_BASE}/finance/courses/${Math.floor(Math.random() * 1000)}/specializations/${Math.floor(Math.random() * 1000)}/academic-groups/${Math.floor(Math.random() * 1000)}/least-academic-groups/${leastAcademicGroupId}/students/?page=${page}&page_size=${pageSize}`
    : `${API_BASE}/finance/students/?page=${page}&page_size=${pageSize}`;

  const response = await fetch(url, { headers: getAuthHeaders() });
  return handleResponse(response);
};

export const exportStudentsExcel = async (leastAcademicGroupId) => {
  const url = leastAcademicGroupId
    ? `${API_BASE}/finance/courses/${Math.floor(Math.random() * 1000)}/specializations/${Math.floor(Math.random() * 1000)}/academic-groups/${Math.floor(Math.random() * 1000)}/least-academic-groups/${leastAcademicGroupId}/students/export-excel/`
    : `${API_BASE}/finance/students/export-excel/`;

  const response = await fetch(url, { headers: getAuthHeaders() });
  if (!response.ok) throw new Error('Export failed');

  const blob = await response.blob();
  const url_obj = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url_obj;
  a.download = `students_finance_${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url_obj);
};

// Course Fee Dashboard API
export const fetchCourseFeeDashboard = async (includeAnalytics = true) => {
  const response = await fetch(
    `${API_BASE}/finance-dashboard/course-fees/?analytics=${includeAnalytics}`,
    { headers: getAuthHeaders() }
  );
  return handleResponse(response);
};
